import React, { useEffect, useState } from 'react';
import { QrReader } from 'react-qr-reader';

const QRScanner: React.FC<{ handleGetData: (data: any) => void }>
    = ({ handleGetData }) => {
        const [data, setData] = useState('');
        const [error, setError] = useState('');
        const [permissionDenied, setPermissionDenied] = useState(true);

        const checkCameraPermission = async () => {
            try {
                await navigator.mediaDevices.getUserMedia({ video: true });
                setPermissionDenied(false);
            } catch (err) {
                setPermissionDenied(true);
                console.error("Camera permission denied", err);
            }
        };

        useEffect(() => {
            if (data && data.length > 0) {

                handleGetData(data)
            }

        }, [data, handleGetData]);

        useEffect(() => {
            checkCameraPermission();
        }, []);

        return (
            <div style={{ textAlign: 'center' }}>
                <h2>QR Scanner</h2>
                {permissionDenied ? (
                    <p style={{ color: 'red' }}>Camera access is required. Please enable it in your browser settings.</p>
                ) : (
                    <div style={{ width: '300px', margin: '0 auto' }}>
                        <QrReader
                            onResult={(result: any, error: any) => {
                                if (result) {
                                    if (result.toString() !== data)
                                        setData(result.text);
                                }
                                if (error) {
                                    setError(error.message);
                                }
                            }}
                            constraints={{ facingMode: 'environment' }}
                            containerStyle={{ width: '100%' }}
                        />
                    </div>
                )}
                {error && <p style={{ color: 'red' }}>Error: {error}</p>}
            </div>
        );
    };

export default QRScanner;
